import React from 'react';
import MessageInfo from '../../components/messageInfo/MessageInfo';
import { MetricMonthlyClientKPICard } from './MetricMonthlyClientKPICard';
import { useGetScorecardBonusPenaltyDataQuery } from '../../pages/managerDashboard/managerDashboardSlice';
import GradientDefs from './GradientDefs';

interface PropTypes {
    inputYear?: number;
    inputMonth?: number;
    scorecardVersion?: number;
}

const ScorecardClientKPI = ({
    inputYear,
    inputMonth,
    scorecardVersion,
}: PropTypes) => {
    const { data: monthlyMetricsData } = useGetScorecardBonusPenaltyDataQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: scorecardVersion,
        },
        { skip: !inputYear || !inputMonth || !scorecardVersion }
    );
    
    if (monthlyMetricsData?.data.length > 0) {
        return (
            <>
                <GradientDefs />
                <div className="pe-0 ps-2" style={{ backgroundColor: '#FFFFFF' }}>
                    <h3>Client KPI</h3>
                    <p>
                        Here you can review the Client Target compared to the Scorecard ({monthlyMetricsData?.data[0]?.scorecard_name}) 
                        Targets for each metric. Keep in mind that, in order to prevent Client Penalties, 
                        you must keep your scores above the target.
                    </p>
                    
                    {/* Grid Layout for Cards */}
                    <div 
                        style={{ 
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(480px, 1fr))',
                            gap: '35px',
                            marginTop: '20px',
                            paddingLeft:'35px',
                            paddingRight:'40px',                            
                            paddingBottom:'40px',
                        }}
                    >
                        {monthlyMetricsData?.data.map((element: any, index: number) => {
                            return (
                                <MetricMonthlyClientKPICard
                                    key={element.label}
                                    targetVal={element.target}
                                    metricAttained={element.metric_attained}
                                    metricNameVal={element.label}
                                    metricTypeName={element.metric_type_name}
                                    metricVal={element.metric_value}
                                    metricDirectionId={element.metric_direction_id}
                                    selectedMetric={""}
                                    index={index}
                                    clientTargetVal={element.client_target}
                                />
                            );
                        })}
                    </div>
                </div>
            </>
        );
    }

    return (
        <div className="col-12 col-md-12 col-lg-9 ps-4 pb-4 h-100">
            <MessageInfo
                title="No results found."
                message="Try adjusting the month or scorecard filter above."
                rowHeight="208px"
            />
        </div>
    );
};

export default ScorecardClientKPI;